import { render, staticRenderFns } from "./deleteConfirm.vue?vue&type=template&id=60367796&scoped=true"
import script from "./deleteConfirm.vue?vue&type=script&lang=js"
export * from "./deleteConfirm.vue?vue&type=script&lang=js"
import style0 from "./deleteConfirm.vue?vue&type=style&index=0&id=60367796&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60367796",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60367796')) {
      api.createRecord('60367796', component.options)
    } else {
      api.reload('60367796', component.options)
    }
    module.hot.accept("./deleteConfirm.vue?vue&type=template&id=60367796&scoped=true", function () {
      api.rerender('60367796', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/deleteConfirm.vue"
export default component.exports